import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/Logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="absolute top-0 w-full z-30 text-[#e0750b]">
      <nav className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-10 py-3 sm:py-4 flex justify-between items-center">
        {/* Logo and Brand */}
        <div className="flex items-center text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold font-serif whitespace-nowrap">
          <Link to="/home" className="flex items-center gap-2 sm:gap-2.5 md:gap-3">
            <img className="h-6 sm:h-7 md:h-8 lg:h-9 xl:h-10 w-auto" src={logo} alt="Logo" />
            <span>REVA INDUSTRIES</span>
          </Link>
        </div>

        {/* Hamburger Button */}
        <button
          className="lg:hidden flex flex-col justify-center items-center w-8 sm:w-9 md:w-10 h-8 sm:h-9 md:h-10 space-y-1 sm:space-y-1.5 z-50 relative"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span
            className={`w-6 sm:w-7 md:w-8 h-1 bg-[#e0750b] rounded-full transform transition duration-300 ${isOpen ? 'rotate-45 translate-y-2 sm:translate-y-2.5' : ''
              }`}
          ></span>
          <span
            className={`w-6 sm:w-7 md:w-8 h-1 bg-[#e0750b] rounded-full transition duration-300 ${isOpen ? 'opacity-0' : ''
              }`}
          ></span>
          <span
            className={`w-6 sm:w-7 md:w-8 h-1 bg-[#e0750b] rounded-full transform transition duration-300 ${isOpen ? '-rotate-45 -translate-y-2 sm:-translate-y-2.5' : ''
              }`}
          ></span>
        </button>

        {/* Nav Links */}
        <ul
          className={`lg:flex lg:items-center lg:gap-6 xl:gap-8 text-base sm:text-lg md:text-lg lg:text-xl absolute lg:static top-full left-0 w-full lg:w-auto bg-[#1a1a1a] lg:bg-transparent transition-all duration-300 ease-in-out ${isOpen ? 'max-h-screen opacity-100 py-4 sm:py-5 md:py-6' : 'max-h-0 opacity-0 lg:opacity-100 lg:max-h-full'
            } overflow-hidden lg:overflow-visible`}
        >
          {[
            { name: 'Home', path: '/home' },
            { name: 'About', path: '/about' },
            { name: 'Products', path: '/products' },
            { name: 'Materials', path: '/materials' },
            { name: 'Contact', path: '/contact' },
          ].map(({ name, path }) => (
            <li key={name}>
              <NavLink
                to={path}
                className={({ isActive }) =>
                  `block py-2 sm:py-2.5 md:py-3 px-4 sm:px-5 md:px-6 lg:p-0 font-medium text-[#e0750b] hover:text-[#f00404f2] transition-colors ${isActive ? 'text-[#f00404f2]' : ''
                  }`
                }
                onClick={closeMenu}
              >
                {name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;